import Hotjar from '@hotjar/browser';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function identifyUserHJ(user) {
  if (Hotjar.isReady()) {
    Hotjar.identify(user.user, {
      email: user.user,
      name: user.name || '',
      maintainer: user.permissions.isUserManut || false,
      admin: user.permissions.isAdminSistema || false,
      instalador: user.permissions.isInstaller || false,
      validator: user.permissions.isParceiroValidador || false,
    });
    Hotjar.event('user_identified');
  }
}

export function HotjarRouteListener({ enabled = true }: { enabled?: boolean }) {
  const { pathname, search } = useLocation();
  useEffect(() => {
    if (!enabled) return;
    (window as any).hj?.('stateChange', pathname + search);
  }, [enabled, pathname, search]);
  return null;
}

export function sendEventHotjar(name: string) {
  if (Hotjar.isReady()) Hotjar.event(name);
  else (window as any).hj?.('event', name);
}

export function trackLoginArrival(email?: string): void {
  if (!Hotjar.isReady()) return;
  if (email) {
    Hotjar.identify(email, { email });
  }
  Hotjar.event('chegada_login');
}

export function trackLoginCompleted(): void {
  if (Hotjar.isReady()) Hotjar.event('login_concluido');
}
